<div class="container-dropdown">
  <ng-container *ngTemplateOutlet="template"></ng-container>
  <ng-template #defaultTpl>
    <ng-content></ng-content>
  </ng-template>
</div>
